import "./styles/styles.scss";
import { Application } from "@hotwired/stimulus";
import { definitionsFromContext } from "@hotwired/stimulus-webpack-helpers"
window.Stimulus = Application.start()
const context = require.context("./controllers", true, /\.js$/);
Stimulus.load(definitionsFromContext(context))

// // Image fix for Safari
// document.addEventListener('turbo:render', () => {
//   if (navigator.userAgent.match(/Version\/[\d.]+.*Safari/)) {
//     document.querySelectorAll('picture').forEach((img) => {
//       img.outerHTML = img.outerHTML; // eslint-disable-line no-param-reassign, no-self-assign
//     });
//   }
// });
